import { Component, Inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { DialogFormService } from 'src/app/services/dialog-form.service';
import { DialogAddClientComponent } from '../dialog-add-client/dialog-add-client.component';
import { DialogService } from 'src/app/services/dialog.service';
import { AuthService } from 'src/app/services/auth.service';
import { Company } from 'src/app/models/company';
import { AddClientDto } from 'src/app/models/dialog-dto/add-client.dto';
import {
  CompanyItemDto,
  CompanyListItemDto,
} from 'src/app/models/dialog-dto/company-list-item.dto';
import { CustomerItemDto } from 'src/app/models/dialog-dto/customer-list-item.dto';
import { shouldSkipClientStep } from 'src/app/utils/client-scope';

interface AddCustomerDialogData {
  guid: string;
  client: string;
}

@Component({
  selector: 'app-dialog-add-customer',
  templateUrl: './dialog-add-customer.component.html',
  styleUrl: './dialog-add-customer.component.scss',
})
export class DialogAddCustomerComponent {
  @ViewChild('stepper') stepper!: MatStepper;

  guid: string = '';
  clientSelectForm: FormGroup;
  companyForm: FormGroup;

  initialClient: CompanyItemDto | undefined;
  initialCustomer: AddClientDto | undefined

  accessibleClients: CompanyListItemDto[] = [];

  constructor(
    public dialogService: DialogService,
    private dialogFormService: DialogFormService,
    public dialogRef: MatDialogRef<DialogAddClientComponent>,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: AddCustomerDialogData
  ) {
    this.clientSelectForm = this.dialogFormService.newCompanySelectForm();
    this.companyForm = this.dialogFormService.newCompanyForm();

    if (data?.client) {
      this.dialogService.getSelectedClient(data.client).subscribe((client) => {
        this.clientSelectForm.get('id')?.setValue(client.company.id);
        this.initialClient = client;
      });
    }

    if (data?.guid) {
      this.guid = data.guid;
      this.dialogService
        .getEditCustomerData(data.guid)
        .subscribe((customer) => {
          this.initialCustomer = customer
          this.setInitialData(customer, this.companyForm);

          this.dialogService
            .getSelectedClient(customer.client.id)
            .subscribe((client) => {

              this.clientSelectForm.get('id')?.setValue(client.company.id);
              this.initialClient = client;
            });
        });
    }

    if (this.authService.checkRole(['Client'])) {
      this.dialogService.getMyClientsList().subscribe((clients) => {
        this.accessibleClients = clients;
        if (shouldSkipClientStep(clients.length, true)) {
          this.clientSelectForm.get('id')?.setValue(clients[0].company.id);
          setTimeout(() => this.stepper?.next(), 0);
        }
      });
    }
  }
  setInitialData(customer: AddClientDto, form: FormGroup) {
    form.get('name')?.setValue(customer.company.name);
    form.get('country')?.setValue(customer.company.country);
    form.get('city')?.setValue(customer.company.city);
    form.get('zipcode')?.setValue(customer.company.zipcode);
    form.get('street')?.setValue(customer.company.street);
  }

  save() {
    var clientId: number = 0;

    this.dialogService
      .getClientByCompanyId(this.clientSelectForm.get('id')?.value)
      .subscribe((client) => {
        clientId = client.client_id;
        this.dialogFormService
          .saveAddCustomerForm(
            clientId,
            this.companyForm,
            this.guid
          )
          .subscribe((result: { success: any }) => {
            if (result.success) {
              this.dialogRef.close(result.success);
            }
            return result
          });
      });
  }
}
